import { useParams } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';
import MODULE_TO_PAGE_MAP from '../pages/analytics/simulator/home/types/simulation-module-to-page-map';
import Storage from '../utils/storage/storage';

export default function useModuleMetadata({
  module
}: {
  module: MODULE_TO_PAGE_MAP;
}) {
  const { source: sourceId } = Storage.getSourceId();
  const { id: scenarioId } = useParams();
  const { moduleNameToModuleIdMap } = useAppSelector(
    (state) => state.simulatorHome
  );

  return {
    sourceId: Number(sourceId),
    scenarioId: Number(scenarioId),
    moduleId: moduleNameToModuleIdMap[module]
  };
}
